/* ============================================================
   MARLENOIR — Theme JavaScript
   FadeIn scroll animations, hamburger menu, FAQ accordion
   ============================================================ */

(function () {
  'use strict';

  /* ---- FADE-IN ON SCROLL (IntersectionObserver) ---- */
  function initFadeIn() {
    var els = document.querySelectorAll('.fade-in');
    if (!els.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '-50px 0px', threshold: 0 }
    );

    els.forEach(function (el) {
      observer.observe(el);
    });
  }

  /* ---- HAMBURGER MENU ---- */
  function initHamburger() {
    var btn = document.querySelector('.hamburger');
    var overlay = document.getElementById('mobile-menu');
    if (!btn || !overlay) return;

    btn.addEventListener('click', function () {
      var isOpen = btn.classList.toggle('is-open');
      if (isOpen) {
        overlay.removeAttribute('hidden');
        // Force reflow before adding class for transition
        overlay.offsetHeight;
        overlay.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      } else {
        overlay.classList.remove('is-open');
        document.body.style.overflow = '';
        setTimeout(function () {
          if (!overlay.classList.contains('is-open')) {
            overlay.setAttribute('hidden', '');
          }
        }, 300);
      }
    });

    // Close menu on link click
    overlay.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        btn.classList.remove('is-open');
        overlay.classList.remove('is-open');
        document.body.style.overflow = '';
        setTimeout(function () {
          overlay.setAttribute('hidden', '');
        }, 300);
      });
    });
  }

  /* ---- FAQ ACCORDION ---- */
  function initFaq() {
    var items = document.querySelectorAll('.pdp-faq-item');
    if (!items.length) return;

    items.forEach(function (item) {
      var header = item.querySelector('.pdp-faq-header');
      if (!header) return;

      header.addEventListener('click', function () {
        var wasOpen = item.classList.contains('is-open');

        // Close all others
        items.forEach(function (other) {
          other.classList.remove('is-open');
        });

        // Toggle current
        if (!wasOpen) {
          item.classList.add('is-open');
        }
      });
    });
  }

  /* ---- CART QUANTITY AJAX UPDATE ---- */
  function initCart() {
    var wraps = document.querySelectorAll('.cart-item-qty-wrap');
    if (!wraps.length) return;

    function updateCart(key, quantity, wrap) {
      var item = wrap.closest('.cart-item');
      item.style.opacity = '0.5';

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (quantity === 0) {
            item.remove();
            if (cart.item_count === 0) location.reload();
            updateTotals(cart);
            return;
          }
          var lineItem = cart.items.find(function (i) { return i.key === key; });
          if (lineItem) {
            var isPreorder = item.hasAttribute('data-preorder');
            var displayPrice = isPreorder ? Math.floor(lineItem.final_line_price / 10) : lineItem.final_line_price;
            var priceEl = item.querySelector('.cart-item-price');
            if (priceEl) priceEl.textContent = formatMoney(displayPrice);
          }
          updateTotals(cart);
          item.style.opacity = '1';
        })
        .catch(function () {
          item.style.opacity = '1';
        });
    }

    function updateTotals(cart) {
      var depositTotal = 0;
      var remainingTotal = 0;
      var cartItems = document.querySelectorAll('.cart-item');

      cart.items.forEach(function (lineItem, index) {
        var el = cartItems[index];
        var isPreorder = el && el.hasAttribute('data-preorder');
        if (isPreorder) {
          var deposit = Math.floor(lineItem.final_line_price / 10);
          depositTotal += deposit;
          remainingTotal += lineItem.final_line_price - deposit;
        } else {
          depositTotal += lineItem.final_line_price;
        }
      });

      var totalEl = document.querySelector('.cart-total-price');
      if (totalEl) totalEl.textContent = formatMoney(depositTotal);

      var deferredEl = document.querySelector('.cart-deferred-price');
      if (deferredEl) deferredEl.textContent = formatMoney(remainingTotal);
    }

    function formatMoney(cents) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' €';
    }

    wraps.forEach(function (wrap) {
      var input = wrap.querySelector('.cart-item-qty');
      var minus = wrap.querySelector('.qty-minus');
      var plus = wrap.querySelector('.qty-plus');
      var key = wrap.getAttribute('data-key');

      minus.addEventListener('click', function () {
        var val = Math.max(0, parseInt(input.value) - 1);
        input.value = val;
        updateCart(key, val, wrap);
      });

      plus.addEventListener('click', function () {
        var val = Math.min(10, parseInt(input.value) + 1);
        input.value = val;
        updateCart(key, val, wrap);
      });

      input.addEventListener('change', function () {
        var val = Math.max(0, Math.min(10, parseInt(input.value) || 0));
        input.value = val;
        updateCart(key, val, wrap);
      });
    });
  }

  /* ---- MOBILE GALLERY SCROLL HINT ---- */
  function initGalleryHint() {
    var gallery = document.querySelector('.pdp-gallery-mobile');
    if (!gallery || gallery.children.length < 2) return;

    // Small nudge scroll to reveal the next image peek
    setTimeout(function () {
      gallery.scrollTo({ left: 40, behavior: 'smooth' });
      setTimeout(function () {
        gallery.scrollTo({ left: 0, behavior: 'smooth' });
      }, 600);
    }, 800);
  }

  /* ---- INIT ---- */
  function init() {
    initFadeIn();
    initHamburger();
    initFaq();
    initCart();
    initGalleryHint();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
